import { EmbedButton as View, Dialog } from 'ui-components'
import { useMapNavStore } from '~map-preview/states/mapNav'
import { useMap } from '~map-preview/states/map'
import { useState } from 'react'

export const EmbedButton = () => {
  const map = useMap()
  const { setSideBar, setOpenDrawer } = useMapNavStore()
  const [open, setOpen] = useState(false)

  const handleOpenEmbed = () => {
    if (!map?.isPublic) {
      setOpen(true)
    } else {
      setOpenDrawer(true)
      setSideBar('embed')
    }
  }

  const handleConfirm = () => {
    setOpen(false)
    setOpenDrawer(true)
    setSideBar('embed')
  }

  return (
    <>
      <View onClick={handleOpenEmbed} />
      <Dialog
        open={open}
        title='Map embed security'
        confirmText='Proceed'
        confirmColor='success'
        cancelText='Cancel'
        onClose={() => setOpen(false)}
        onConfirm={handleConfirm}
      >
        Embedded maps are publicly viewable. Anyone with access to the page
        where this map is embedded can see it, no sign-in required.
      </Dialog>
    </>
  )
}
